import React from 'react';

interface CustomIconGaugeChart1Props extends React.SVGProps<SVGSVGElement> {}

export function CustomIconGaugeChart1({ height, width, ...props }: CustomIconGaugeChart1Props) {
  const primaryFill = 'currentColor';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fill={primaryFill}
        fillRule="evenodd"
        d="M4.266 10.183c-.505.893-.831 1.7-.979 2.422-.147.721-.243 1.46-.287 2.217h3.267c.019-.64.075-1.139.17-1.495.094-.356.31-.834.65-1.434 1.006-1.452 2.456-2.308 4.35-2.57 1.2-.166 2.804.315 3.906 1.273.537.467.986 1.03 1.347 1.688.264.598.43 1.063.498 1.394.068.332.105.713.113 1.144h3.268c.006.022.006-.06 0-.247a10.508 10.508 0 0 0-.17-1.485c-.307-1.651-.976-2.698-1.101-2.907-.301-.505-.734-.978-.977-1.253a8.523 8.523 0 0 0-5.057-2.797c-1.28-.203-2.638-.22-4.193.288-.445.146-.994.37-1.466.603-1.285.63-2.398 1.684-3.34 3.16Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillOpacity=".5"
        fillRule="evenodd"
        d="M2.406 14.868 5 17c.47-.35 3.922-6.846 4.16-6.976.39-.213.771-.354 1.15-.469a5.246 5.246 0 0 1 1.146-.232 5.134 5.134 0 0 1 2.087.26c.601.209 3.345 5.45 3.957 5.917l6-.632c-.562-.546-5.884-7.478-6.5-7.844-1.062-.632-2.976-.774-3.716-.891-1.28-.203-2.638-.22-4.193.288-.445.146-1.039.354-1.467.603-.316.184-.344.137-.87.495-.397.27-3.754 1.092-4.348 7.35Z"
        clipRule="evenodd"
      />
      <path
        fill={primaryFill}
        fillRule="evenodd"
        d="M11.8 17c.607 0 1.131-.555 1.131-1.1 0-.363-.377-1.21-1.131-2.539-.734 1.288-1.1 2.134-1.1 2.539a1.1 1.1 0 0 0 1.1 1.1Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
